import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule, ServicePathProviderService } from '@blk/cwp-ng-framework';
import { AccountApiModule, BASE_PATH as ACCOUNT_BASE_PATH } from '@blk/portfolio-security-server/account';
import { AccountInfoApiModule, BASE_PATH as ACCOUNT_INFO_BASE_PATH } from '@blk/portfolio-security-server/accountInfo';
import { BASE_PATH as PLATFORMS_BASE_PATH, PlatformApiModule } from '@blk/portfolio-security-server/platform';
import { ConfigLayerModule } from '@ddt-web/config-layer';

import { PartnerNotificationService, PartnerPortfoliosApiService } from './services';

export function getPlatformsBasePath(servicePathProvider: ServicePathProviderService): string {
	return `${servicePathProvider.getServicePath('apigee-path')}/api/wealth/integrations/partners/v1`;
}

export function getAccountInfoBasePath(servicePathProvider: ServicePathProviderService): string {
	return `${servicePathProvider.getServicePath('apigee-path')}/api/wealth/integrations/partners/v1`;
}

@NgModule({
	imports: [CommonModule, CwpNgFrameworkModule, ConfigLayerModule, PlatformApiModule, AccountInfoApiModule, AccountApiModule],
	declarations: [],
	providers: [
		{
			provide: PLATFORMS_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getPlatformsBasePath
		},
		{
			provide: ACCOUNT_INFO_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getPlatformsBasePath
		},
		{
			provide: ACCOUNT_BASE_PATH,
			deps: [ServicePathProviderService],
			useFactory: getPlatformsBasePath
		},
		PartnerPortfoliosApiService,
		PartnerNotificationService
	]
})
export class ImportPartnerPortfoliosModule { }
